// Process Video Button Enhancement
document.addEventListener('DOMContentLoaded', function() {
  // Find all process video buttons
  const videoButtons = document.querySelectorAll('.video-button');
  
  if (videoButtons.length > 0) {
    videoButtons.forEach(button => {
      button.addEventListener('click', function() {
        const sectionId = this.getAttribute('data-video-play');
        const videoContainer = document.getElementById(`video-${sectionId}-container`);
        const videoIframe = document.getElementById(`video-${sectionId}`);
        
        if (videoContainer && videoIframe) {
          // Add active class to container
          videoContainer.classList.add('video--active');
          
          // If YouTube iframe API is loaded
          if (window.YT && videoIframe.getAttribute('data-video-id')) {
            const enableSound = videoContainer.closest('[data-enable-sound]').getAttribute('data-enable-sound') === 'true';
            
            // Create new YouTube player if not already created
            if (!videoIframe.player) {
              videoIframe.player = new window.YT.Player(videoIframe, {
                videoId: videoIframe.getAttribute('data-video-id'),
                playerVars: {
                  modestbranding: true,
                  showinfo: false,
                  controls: true,
                  rel: 0,
                  mute: !enableSound
                },
                events: {
                  onReady: function(event) {
                    event.target.playVideo();
                  }
                }
              });
            } else {
              // If player already exists, just play it
              videoIframe.player.playVideo();
            }
          }
          
          // Hide the process title and button
          const processTitle = videoContainer.closest('.process-section').querySelector('.process-title');
          const buttonContainer = button.closest('div');
          
          if (processTitle) processTitle.style.opacity = 0;
          if (buttonContainer) buttonContainer.style.opacity = 0;
        }
      });
      
      // Add a hover effect with tooltip
      button.addEventListener('mouseenter', function() {
        const instruction = this.querySelector('.process-instruction');
        if (instruction) {
          instruction.style.opacity = 1;
        }
      });
      
      button.addEventListener('mouseleave', function() {
        const instruction = this.querySelector('.process-instruction');
        if (instruction) {
          instruction.style.opacity = 0;
        }
      });
    });
  }
}); 